import { createStore, applyMiddleware, combineReducers } from 'redux';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';
import {
  chargePointsReducer,
  notificationReducer,
  statsReducer,
  userReducer,
  websocketReducer,
  ocppTagsReducer,
  virtualGroupReducer,
  voucherReducer,
  searchUserReducer,
  searchTransactionReducer,
  searchOperationReducer,
} from './reducers';

const reducers = combineReducers({
  chargePoints: chargePointsReducer,
  user: userReducer,
  notifications: notificationReducer,
  websocket: websocketReducer,
  stats: statsReducer,
  ocppTags: ocppTagsReducer,
  voucher: voucherReducer,
  virtualGroup: virtualGroupReducer,
  searchUser: searchUserReducer,
  searchTransaction: searchTransactionReducer,
  searchOperation: searchOperationReducer,
});

export default createStore(
  reducers,
  composeWithDevTools(applyMiddleware(thunk)),
);
